import {AxiosInstance} from 'axios';
import createAxiosInstance from './AxiosInstance';
import {NfcScanResult} from '../components/shared/nfc/types';

export const ALARM_CHIP_TEXT = 'alarm-couple-secret';
export const SESSION_EXPIRED_STATUS = 401;

export interface AlarmCouplingResult {
    lobbyId: number;
    alarmCoupled: boolean;
}

const STATUS_MESSAGES: Record<number, string> = {
    400: 'De koppelgegevens zijn ongeldig. Scan de alarmchip opnieuw.',
    401: 'Je sessie is verlopen. Log opnieuw in.',
    403: 'De alarmchip is geweigerd of je hebt geen toegang om te koppelen.',
    404: 'Deze lobby bestaat niet meer.',
};

export class AlarmCouplingError extends Error {
    constructor(public status?: number) {
        super(STATUS_MESSAGES[status ?? 0] ?? 'Alarm koppelen is mislukt. Probeer het opnieuw.');
    }
}

export const getAlarmChipText = (result: NfcScanResult): string => {
    const [record] = result.records;
    if (result.records.length !== 1 || record.type !== 'text' || record.value !== ALARM_CHIP_TEXT) {
        throw new Error('Dit is geen geldige alarmchip');
    }
    return record.value;
};

export const hasExactNfcText = (result: NfcScanResult, text: string): boolean =>
    result.records.length === 1 && result.records[0].type === 'text' && result.records[0].value === text;

export const getResponseStatus = (error: unknown): number | undefined =>
    (error as {response?: {status?: number}} | null)?.response?.status;

export const coupleLobbyAlarm = async (
    request: {lobbyId: number; secret: string; signal: AbortSignal},
    client: AxiosInstance = createAxiosInstance(),
): Promise<AlarmCouplingResult> => {
    if (!localStorage.getItem('jwt')) throw new AlarmCouplingError(SESSION_EXPIRED_STATUS);
    try {
        const response = await client.post<AlarmCouplingResult>(
            `/lobbies/${request.lobbyId}/alarm-coupling`,
            {secret: request.secret},
            {signal: request.signal, headers: {'Content-Type': 'application/json'}},
        );
        if (response.data.lobbyId !== request.lobbyId || response.data.alarmCoupled !== true) {
            throw new AlarmCouplingError();
        }
        return response.data;
    } catch (error) {
        throw new AlarmCouplingError(getResponseStatus(error));
    }
};
